import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const AppsPage = lazy(() => import('./components/AppsPage'))

class AppsPageComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['project-id', 'team-uuid']
	}

	override render() {
		const projectId = this.prop('project-id')
		const isAdmin = !!this.jsonProp('is-admin')
		const teamUuid = this.prop('team-uuid')

		return (
			<RootProviders>
				<AppsPage projectId={projectId} teamUuid={teamUuid} isAdmin={isAdmin} />
			</RootProviders>
		)
	}
}

customElements.define('apps-page', AppsPageComponent)
